import React from 'react';
import { Card, Title, Text, Stack, Anchor } from '@mantine/core';

const PrivacyPage: React.FC = () => {
  return (
    <Stack gap="md">
      <Title order={2}>Datenschutz</Title>
      
      <Card withBorder p="md">
        <Stack gap="md">
          <Title order={4}>Google Adsense</Title>
          <Text>
            Diese Website benutzt Google Adsense, einen Webanzeigendienst der Google Inc., USA (&quot;Google&quot;). 
            Google Adsense verwendet sog. &quot;Cookies&quot; (Textdateien), die auf Ihrem Computer gespeichert werden und 
            die eine Analyse der Benutzung der Website durch Sie ermöglicht. Google Adsense verwendet auch sog. 
            &quot;Web Beacons&quot; (kleine unsichtbare Grafiken) zur Sammlung von Informationen. Durch die Verwendung des 
            Web Beacons können einfache Aktionen wie der Besucherverkehr auf der Webseite aufgezeichnet und 
            gesammelt werden.
          </Text>
          <Text>
            Die durch den Cookie und/oder Web Beacon erzeugten Informationen über Ihre Benutzung dieser Website 
            (einschließlich Ihrer IP-Adresse) werden an einen Server von Google in den USA übertragen und dort 
            gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website im Hinblick auf die 
            Anzeigen auszuwerten, um Reports über die Websiteaktivitäten und Anzeigen für die Websitebetreiber 
            zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene 
            Dienstleistungen zu erbringen.
          </Text>
          <Text>
            Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich 
            vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in keinem 
            Fall Ihre IP-Adresse mit anderen Daten der Google in Verbindung bringen.
          </Text>
          <Text>
            Das Speichern von Cookies auf Ihrer Festplatte und die Anzeige von Web Beacons können Sie verhindern, 
            indem Sie in Ihren Browser-Einstellungen {"keine Cookies akzeptieren"} wählen (Im MS Internet-Explorer 
            unter {"Extras"} {" > "} {"Internetoptionen"} {" > "} {"Datenschutz"} {" > "} {"Einstellung"}; im Firefox unter {"Extras"} {" > "} {"Einstellungen"} {" > "} 
            {"Datenschutz"} {" > "} {"Cookies"}); wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht 
            sämtliche Funktionen dieser Website voll umfänglich nutzen können.
          </Text>
          <Text>
            Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten 
            durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
          </Text>
        </Stack>
      </Card>

      <Card withBorder p="md">
        <Stack gap="md">
          <Title order={4}>Datenschutzbelehrung gem. Art. 13 und 14 DSGVO</Title>
          
          <Title order={5}>1. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen</Title>
          <Text>
            Diese Datenschutzhinweise gelten für die Datenverarbeitung durch:<br />
            <strong>Galek GmbH</strong><br />
            Am Brunnenbichl 2<br />
            82398 Polling<br />
            E-Mail: <Anchor href="mailto:office@timbertrack.de">office@timbertrack.de</Anchor>
          </Text>
          
          <Title order={5}>2. Kontaktdaten des Datenschutzbeauftragten</Title>
          <Text>
            Sie können unseren Datenschutzbeauftragten unter folgender Adresse erreichen:<br />
            <strong>Galek GmbH</strong><br />
            Am Brunnenbichl 2<br />
            82398 Polling<br />
            E-Mail: <Anchor href="mailto:office@timbertrack.de">office@timbertrack.de</Anchor>
          </Text>
          
          <Title order={5}>3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck und deren Verwendung</Title>
          
          <Title order={6}>3.1) Erhebung und Speicherung</Title>
          <Text>
            Wenn Sie erstmals in Kontakt mit uns treten und/oder mit uns einen Vertrag schließen, erheben wir in der Regel folgende Informationen:
          </Text>
          <Text>
            - Firmenname<br />
            - Anrede, Vorname, Nachname und Funktion der benannten Ansprechpartner<br />
            - Anschrift (falls abweichend: Rechnungsadresse)<br />
            - eine gültige E-Mail-Adresse<br />
            - Telefonnummer (Festnetz und/oder Mobilfunk)<br />
            - Faxnummer<br />
            - Ggf. Geburtsdatum<br />
            - Bankverbindung
          </Text>
          <Text>
            Wir weisen Ihnen in unserem System eine Kundennummer zu.
          </Text>
          
          <Title order={6}>3.2) Wofür verarbeiten wir Ihre Daten (Zweck der Verarbeitung) und auf welcher Rechtsgrundlage</Title>
          
          <Title order={6}>3.2.1) Zur Erfüllung von vertraglichen Pflichten und/oder Durchführung von vorvertraglichen Maßnahmen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO)</Title>
          <Text>
            Wir verarbeiten Ihre personenbezogenen Daten zur Erfüllung von vertraglichen Pflichten und/oder 
            Durchführung von vorvertraglichen Maßnahmen, die auf Grund Ihrer Anfrage erfolgen, d.h. insbesondere
          </Text>
          <Text>
            - zur Vertragserfüllung;<br />
            - zur Korrespondenz;<br />
            - zur Rechnungsstellung;<br />
            - zur Abwicklung von Gewährleistungsansprüchen;<br />
            - zur Abwicklung von evtl. vorliegenden Haftungsansprüchen sowie der Geltendmachung etwaiger Ansprüche gegen Sie.
          </Text>
          
          <Title order={6}>3.2.2) Aufgrund Ihrer Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO)</Title>
          <Text>
            Soweit Sie uns eine Einwilligung zur Verarbeitung von personenbezogenen Daten erteilt haben, ist die 
            jeweilige Einwilligung Rechtsgrundlage für die dort genannte Verarbeitung. Dies betrifft insbesondere
          </Text>
          <Text>
            - Erhebung und Speicherung weiterer personenbezogenen Daten<br />
            - Werbliche Ansprachen per Telefon oder E-Mail<br />
            - Erhalt eines E-Mail-Newsletters
          </Text>
          <Text>
            Sie können Einwilligungen jederzeit mit Wirkung für die Zukunft widerrufen. Wir setzen Sie davon in Kenntnis, 
            dass durch den Widerruf der Einwilligung die Rechtmäßigkeit der aufgrund der Einwilligung bis zum 
            Widerruf erfolgten Verarbeitung nicht berührt wird.
          </Text>
          
          <Title order={6}>3.2.3) Im Rahmen der Interessenabwägung (Art. 6 Abs. 1 S. 1 lit. f) DSGVO)</Title>
          <Text>
            Wir können Ihre Daten außerdem auf Basis einer Interessenabwägung zur Wahrung der berechtigten 
            Interessen von uns oder von Dritten verwenden. Dies erfolgt bspw. zu folgenden Zwecken:
          </Text>
          <Text>
            - Führen einer Auftragshistorie für unsere zukünftigen Serviceleistungen<br />
            - Zur Kundenberatung und -betreuung und dem Vertrieb<br />
            - allgemeine Geschäftssteuerung und Weiterentwicklung von Dienstleistungen und Produkten<br />
            - Werbung, Markt- und Meinungsforschung<br />
            - Geburtstags- und Jubiläumsglückwünsche<br />
            - Weihnachtsgrüße
          </Text>
          <Text>
            Unser Interesse an der jeweiligen Verarbeitung ergibt sich aus den jeweiligen Zwecken und ist im Übrigen 
            wirtschaftlicher Natur. Soweit dies möglich und angemessen ist, verarbeiten wir Ihre Daten pseudonymisiert 
            oder anonymisiert.
          </Text>
          
          <Title order={6}>3.2.4) Aufgrund gesetzlicher Vorgaben (Art. 6 Abs. 1 S. 1 lit. c) DSGVO)</Title>
          <Text>
            Wir unterliegen verschiedenen rechtlichen Verpflichtungen, wie bspw. gesetzlichen handelsrechtlichen 
            Aufbewahrungs- und Dokumentationspflichten (aus HGB, StGB oder AO).
          </Text>
          
          <Title order={5}>4. Weitergabe von Daten an Dritte und Auftragsverarbeiter</Title>
          <Text>
            Auch bei der Weitergabe von personenbezogenen Daten handelt es sich um eine Verarbeitung im Sinne der 
            vorangegangenen Ziffer 3. Der Schutz Ihrer personenbezogenen Daten liegt uns sehr am Herzen. Aus diesem 
            Grund sind wir besonders vorsichtig, wenn es darum geht Ihre Daten an Dritte weiterzugeben.
          </Text>
          <Text>
            Eine Übermittlung Ihrer personenbezogenen Daten an Dritte erfolgt in der Regel zu folgenden Zwecken.
          </Text>
          <Text>
            - Auftragsverarbeiter, mit denen wir eine Vereinbarung nach Art. 28 DSGVO geschlossen haben<br />
            - Versand (z.B. Versanddienstleister, Waren-Lieferanten)<br />
            - Für die Inanspruchnahme von Sonderkonditionen<br />
            - Angebots-/Aktionserstellung<br />
            - Zahlungsabwicklung (z.B. Zahlungsdienstleister, Zentralregulierer)<br />
            - Lieferung von Printmedien<br />
            - Buchhaltung (z.B. Steuerberater)<br />
            - Rechtsstreitigkeiten (z.B. Anwalt)<br />
            - Beurkundungen (Notar)<br />
            - Kommunikationsplattform (z.B. E-Mail, WhatsApp, andere Messenger-Dienste)<br />
            - Newsletter-Anbieter (für den Versand von kundenspezifischen Newslettern)<br />
            - Webhoster (für Domain Registrierung und E-Mail-Einrichtung)
          </Text>
          
          <Title order={5}>5. Löschung</Title>
          <Text>
            Ihre personenbezogenen Daten werden von uns gelöscht, soweit diese für die Zwecke, für die sie erhoben 
            oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig sind, die Verarbeitung nicht zur 
            Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen 
            Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder 
            Verteidigung von Rechtsansprüchen erforderlich sind.
          </Text>
          
          <Title order={5}>6. Betroffenenrechte</Title>
          <Text>
            Sie haben das Recht:
          </Text>
          <Text>
            - gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. 
              Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die 
              Zukunft nicht mehr fortführen dürfen;<br />
            - gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen. 
              Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, 
              die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante 
              Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung 
              oder Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft ihrer Daten, sofern diese nicht 
              bei uns erhoben wurden, sowie über das Bestehen einer automatisierten Entscheidungsfindung einschließlich 
              Profiling und ggf. aussagekräftigen Informationen zu deren Einzelheiten verlangen;<br />
            - gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns 
              gespeicherten personenbezogenen Daten zu verlangen;<br />
            - gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, 
              soweit diese für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr 
              notwendig sind, die Verarbeitung nicht zur Ausübung des Rechts auf freie Meinungsäußerung und Information, 
              zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur 
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;<br />
            - gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, 
              soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber 
              deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, 
              Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch 
              gegen die Verarbeitung eingelegt haben;<br />
            - gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, 
              gängigen und maschinenlesebaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen 
              zu verlangen und<br />
            - gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür 
              an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes wenden.
          </Text>
          
          <Title order={5}>7. Widerspruchsrecht</Title>
          <Text>
            Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f 
            DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer 
            personenbezogenen Daten einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen Situation 
            ergeben.
          </Text>
          <Text>
            Möchten Sie von Ihrem Widerspruchsrecht Gebrauch machen, senden Sie uns eine E-Mail an: 
            <Anchor href="mailto:office@timbertrack.de">office@timbertrack.de</Anchor>
          </Text>
        </Stack>
      </Card>
      
      <Card withBorder p="md">
        <Text size="sm" c="dimmed">
          © Galek GmbH<br />
          webdesign: frazo.de
        </Text>
      </Card>
    </Stack>
  );
};

export default PrivacyPage;
